export default __webpack_public_path__ + "images/overnight.608edc5.jpg";